package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.IdentityData
import com.neurobs.ccabserver.translationadmin.Main
import com.neurobs.js.controller.AdminPanelController
import com.neurobs.js.dom.ElementFactory
import com.neurobs.js.dom.ElementFactory.PanelView
import com.neurobs.js.view.{Container, Gui}
import com.neurobs.util.Guid
import org.scalajs.dom.raw.Event
import com.neurobs.js.dom.DOMViewElement._
import scalatags.JsDom.all._

class TranslationAdminController(gui: Gui, userData: IdentityData) extends AdminPanelController {

	val reactDiv = div().render

  private val panel: PanelView = {

    val temp = new PanelView(title = "Translation Admin", showRefresh = false, fullWidth = true)
    val closeButton = ElementFactory.makeLink(text = "Close")
    closeButton.onclick =  (_:Event) => delegate.foreach(_.close())
    temp.setRightCorner(closeButton)
    temp.container.addChild(reactDiv)
    temp
  }

  override def didAppear(): Unit = {
    new Main(reactDiv, userData)
  }

  override def container: Container = {
    panel.container
  }

}
